import React, {Component} from 'react';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Redirect} from 'react-router-dom';
import {logOut, setAuthRedirect} from '../../../actions/auth';
import {WithAbly, PageLoader} from '../../common';
import {fetchUser, setSidebarStatus} from '../../../actions/user';
import AuthTokenUtils from '../../../utils/authToken';

export default function RequireAuthenticationHoc(WrappingComponent) {
  class AuthenticatedComponent extends Component {
    static propTypes = {
      isAuthenticated: PropTypes.bool.isRequired,
      dispatch: PropTypes.func.isRequired,
      currentPath: PropTypes.string.isRequired,
      match: PropTypes.shape().isRequired,
      userId: PropTypes.string,
      fetchUserProfile: PropTypes.func.isRequired,
      toggleSidebar: PropTypes.func.isRequired,
      isTokenExpired: PropTypes.func.isRequired,
    };

    componentDidMount() {
      const {
        dispatch, isAuthenticated, currentPath,
        fetchUserProfile, userId, toggleSidebar,
        isTokenExpired,
      } = this.props;

      if (isTokenExpired()) {
        dispatch(logOut());
      }

      const redirectPath = isAuthenticated ? null : currentPath;

      if (redirectPath) {
        dispatch(setAuthRedirect(redirectPath));
      }
      if (isAuthenticated && !userId) {
        fetchUserProfile();
      }

      toggleSidebar({status: false});
    }

    shouldComponentUpdate(nextProps) {
      const {userId} = this.props;
      const {userId: nextUserId} = nextProps;
      return userId !== nextUserId;
    }

    render() {
      const {isAuthenticated, currentPath, userId, isTokenExpired, ...rest} = this.props;
      const Comp = !isEmpty(userId) ? WithAbly(WrappingComponent) : PageLoader;

      return (
        <div className="layout_root">
          {(isAuthenticated && !isTokenExpired()) ?
            <Comp {...rest}/> :
            <Redirect to="/sign-in"/>
          }
        </div>
      );
    }
  }

  function mapStateToProps(state, ownProps) {
    const {auth} = state;
    const {user: {profile = {}}} = state;
    const {isAuthenticated} = auth;
    const {location} = ownProps;
    const {pathname: currentPath} = location;

    return {
      userId: profile.id,
      isAuthenticated,
      currentPath,
      isTokenExpired: () => AuthTokenUtils.isExpired(),
      ...ownProps,
    };
  }

  function bindActions(dispatch) {
    return {
      dispatch,
      fetchUserProfile: () => dispatch(fetchUser()),
      toggleSidebar: () => dispatch(setSidebarStatus()),
    };
  }

  return connect(mapStateToProps, bindActions)(AuthenticatedComponent);
}
